import Phaser from 'phaser';
import {Button} from "./components/Button";
import {HowToPlayMessage} from "./components/HowToPlayMessage";

export class TitleScene extends Phaser.Scene {

    constructor() {
        super('TitleScene');
    }

    preload() {
        this.load.scenePlugin({
            key: 'rexuiplugin',
            url: 'rexuiplugin.min.js',
            sceneKey: 'rexUI'
        });
    }

    initBackground() {
        let backgroundClass = "background-";
        switch(window._po_gm.config.pulse) {
            case '2':
                backgroundClass += '2';
                break;
            case '3':
                backgroundClass += '3';
                break;
            case '4':
                backgroundClass += '4';
                break;
            default:
                backgroundClass += '1';
        }
        document.body.classList.add(backgroundClass);
    }

    create() {
        this.initBackground();

        this.add.image(375,375, 'branding');

         this.add.image(375,750, 'title-window')
         let self = this;

         new Button(this, 375, 700, 'title-playnow', function() {
             self.scene.start('CrosswordScene');
         }, '', 416, 80);
         new Button(this, 375, 800, 'title-htp', function() {
             new HowToPlayMessage(self.scene.scene, 700, 1334, () => {
             });
         }, '', 500, 80);
    }


}
